/**
 * Links das lojas para download do app RapiDocs.
 */
export const APP_STORE_URL = 'https://apps.apple.com/br/app/rapidocs/id6657992215';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.reports_app';
